module.exports = __webpack_public_path__ + "img/image_4.509a6c97.png";